import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, FormItem, FormLabel, FormMessage } from "~/atoms/form";
import { useCategories } from "~/api/swr/useCategories";
import { ControlledCombobox } from "~/molecules/ControlledCombobox";
import { type DocumentEditFormValues } from "~/hooks/useDocumentEditForm";
import { useDocumentFieldsContext } from "./DocumentFieldsContext";

const mapEntityToOption = (entity: { id: number; title: string }) => ({
  value: entity.id.toString(),
  label: entity.title,
});

export const DocumentCategoryField = () => {
  const { t } = useTranslation();
  const { data: categories } = useCategories();
  const form = useFormContext<DocumentEditFormValues>();
  const { setDocumentValueWithGuard: setClassificationValueWithGuard } =
    useDocumentFieldsContext();

  return (
    <FormField
      control={form.control}
      name="categoryId"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t("commons.document.category")}</FormLabel>
          <ControlledCombobox
            value={field.value}
            options={categories?.map(mapEntityToOption) ?? []}
            placeholder={t("commons.customSelect.selectCategory")}
            onChange={(newValue) =>
              setClassificationValueWithGuard({
                type: "categoryId",
                newValue,
              })
            }
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
